<template>
  <div>
    <ReportModalButton :class="buttonClass" :profileId="profileId"></ReportModalButton>
  </div>
</template>

<script>
import ReportModalButton from '../modules/ReportModalButton';

export default {
  name: 'ReportModalComponent',
  components: { ReportModalButton },
  props: {
    profileId: {
      required: true,
    },
    buttonClass: {
      required: false,
      type: String,
      default: 'button button__link button__link--underline',
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>

</style>
